import ThemeSwatch from './ThemeSwatch';
import { loadTheme } from 'owa-theme';
import { observer } from 'mobx-react';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { getSupportedThemeIds } from 'owa-theme';
import * as React from 'react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import { loadAllThemeResources } from 'owa-theme/lib/orchestrators/loadAllThemeResources';

const styles = require('./Theme.scss');

@observer
export default class ThemeFull extends React.Component<{}, {}> {
    componentDidMount() {
        loadAllThemeResources();
    }

    render() {
        return (
            <div>
                <OptionDescription>{strings.options_theme_description}</OptionDescription>
                <FocusZone
                    className={styles.fullSwatchContainer}
                    direction={FocusZoneDirection.bidirectional}
                    role="listbox">
                    {getSupportedThemeIds().map(id => (
                        <ThemeSwatch themeId={id} key={id} onClick={this.onThemeClick} />
                    ))}
                </FocusZone>
            </div>
        );
    }

    private onThemeClick(themeId: string) {
        loadTheme(themeId);
    }
}
